import { z } from '@hono/zod-openapi'
import { zSelectBenefitApplication } from './benefit-application.zod'

export const zApplicationWithRelations = zSelectBenefitApplication.extend({
    employeeFirstName: z.string().nullable(),
    employeeLastName: z.string().nullable(),
    employeeEmail: z.string().nullable(),
    clientName: z.string().nullable(),
    benefitTitle: z.string().nullable(),
    vendorName: z.string().nullable(),
})

export const zApplicationWithBenefitDetails = zApplicationWithRelations.extend({
    benefitDescription: z.string().nullable().optional(),
    benefitType: z.string().nullable().optional(),
    categoryName: z.string().nullable().optional(),
})

export type ApplicationWithRelations = z.infer<typeof zApplicationWithRelations>
export type ApplicationWithBenefitDetails = z.infer<
    typeof zApplicationWithBenefitDetails
>
